export default __webpack_public_path__ + "static/media/plain-sticker-o.4cfd9624.png";